import React from "react";
import { Container, Row, Col } from "shards-react";
import {firebases,files } from '../config';
import PageTitle from "../components/common/PageTitle";
import FormItem from "../components/common/FormItem";


const baseName = "Notes";
const firebaseDb = firebases.database().ref().child('notes');
const firebaseTypeDb = firebases.database().ref().child('notesType');
const firebaseCourseDb = firebases.database().ref().child('courses');
const firebaseCategoryDb = firebases.database().ref().child('category');
const firebaseSubCategoryDb = firebases.database().ref().child('subCategory');
const firebaseChapterDb = firebases.database().ref().child('chapters');
const firebaseExcerciseDb = firebases.database().ref().child('exercises');
const firebaseQuestionDb = firebases.database().ref().child('questions');
const firebaseLinkedList = [firebaseTypeDb,firebaseCourseDb,firebaseCategoryDb,firebaseSubCategoryDb,firebaseChapterDb,firebaseExcerciseDb,firebaseQuestionDb];


const header = [{"field":"title","label":"Title","sort":"asc","type":"TEXT","editType":"text"},{"field":"thumbnail","label":"Thumbnail","sort":"asc","type":"IMAGE","editType":"file"},
{"field":"shortdesc","label":"Short Description","sort":"asc","type":"EDITOR","editType":"textview"},
{"field":"description","label":"Description","sort":"asc","type":"EDITOR","editType":"textview"},
{"field":"notes","label":"notes","sort":"asc","type":"FILE","editType":"file"},
{"field":"type","label":"Notes Type","sort":"asc","type":"TEXT",editType:"LINKEDLIST"},
{"field":"course","label":"Course","sort":"asc","type":"TEXT",editType:"LINKEDLIST1",filter:"class",
filterId:"course"},

{"field":"class","label":"Class","sort":"asc","type":"TEXT","editType":"LINKEDLIST2",filter:"subject",
filterId:"category"},
{"field":"subject","label":"Subject","sort":"asc","type":"TEXT","editType":"LINKEDLIST3",filter:"chapter",
filterId:"subCategory"},
{"field":"chapter","label":"Chapter","sort":"asc","type":"TEXT","editType":"LINKEDLIST4",filter:"exercise",
filterId:"chapter"},
{"field":"exercise","label":"Exercise","sort":"asc","type":"TEXT","editType":"LINKEDLIST5",filter:"question",
filterId:"exercise"}
,{"field":"question","label":"Question","sort":"asc","type":"TEXT","editType":"LINKEDLIST6"},
{"label":"Actions","field":"actions","sort":"asc","width":110,"type":"ACTIONS"}];
const NotesAdd = () => (
  <Container fluid className="main-content-container px-4">
    <Row noGutters className="page-header py-4">
      <PageTitle title="Notes" subtitle="Add New Notes" sm="4" className="text-sm-left" />
    </Row>
    <Row>
    
      <Col lg="10">
        <FormItem title="Notes Details"
         firebaseLinkedList = {firebaseLinkedList}
          model={header} action="Add New Notes" firebaseDb={firebaseDb} firebaseStorage={files}/>
      </Col>
    </Row>
  </Container>
);

export default NotesAdd;
